export default "__VITE_ASSET__C$ALUK8A__$_?nuxt_component=async&nuxt_component_name=IconFrameShapePilot&nuxt_component_export=default__"